import KML from 'ol/format/KML'
import GeoJSON from 'ol/format/GeoJSON'
import TopoJSON from 'ol/format/TopoJSON'
import GPX from 'ol/format/GPX'
import IGC from 'ol/format/IGC'
import FileUtil from './FileUtil'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
/**
 * ol要素导出成指定类型文件
 * @param {Array<ol.feature>|| ol.feature}
 * @author GuoYun
 */
export const FeaturesWriter = {
  exportFile(features, type) {
    //文件类型
    var lower = type.toLowerCase()
    //文件构造器
    var driver = FormatType[lower]
    //文件名称
    var fileName = 'TEMP_' + lower.toUpperCase() + '.' + lower
    if (driver) {
      this.export(features, driver, fileName)
    }
  },
  exportKML(features) {
    this.export(features, KML, 'temp.kml')
  },
  exportGeoJSON(features) {
    this.export(features, GeoJSON, 'temp.geojson')
  },
  exportTopoJSON(features) {
    this.export(features, TopoJSON, 'temp.topojson')
  },
  exportGPX(features) {
    this.export(features, GPX, 'temp.gpx')
  },
  exportIGC(features) {
    this.export(features, IGC, 'temp.igc')
  },
  export(features, driver, fileName) {
    var format = new driver()
    var str = Array.isArray(features) ? format.writeFeatures(features) : format.writeFeatures([features])
    FileUtil.saveFile(str, fileName)
  },

  /**
   * 将json数组转换成feature数组
   * @param {*} jsonArray
   * @param {*} xFieldName
   * @param {*} yFieldName
   */
  readPointFromJson(jsonArray, xFieldName, yFieldName) {
    var features = []
    jsonArray.forEach((jsonObj) => {
      var x = jsonObj[xFieldName] || 0
      var y = jsonObj[yFieldName] || 0
      var feat = new Feature({
        geometry: new Point({
          coordinates: [x, y],
        }),
        properties: jsonObj,
      })
      features.push(feat)
    })
    return features
  },
}

export const FormatType = {
  kml: KML,
  geojson: GeoJSON,
  topojson: TopoJSON,
  gpx: GPX,
  igc: IGC,
}
